import { useState, createContext, useReducer } from 'react'
import { useEffect } from 'react' // keep for debugging log
import { matchPath, Route, Routes, useLocation } from 'react-router-dom'
import styled, { ThemeProvider } from 'styled-components'
import ReactTooltip from 'react-tooltip'
import { initializeEnv } from './Components/__urlsSystem'
import Global, { themeDesktop, backgroundColor } from './Components/Global'
import PageConfigurator from './Components/PageConfigurator'
import PageViewer from './Components/PageViewer'
import PageArModelViewer from './Components/PageArModelViewer'
import ErrorBoundary from './Components/ErrorBoundary'
import PageSelectorGallery from './Components/PageSelectorGallery'
import PagePersonal from './Components/PagePersonal'
import { logInit } from './Components/_logging.js'

logInit()
initializeEnv()

export const GlobalStateContext = createContext({ value: null, setValue: () => { } })
export const ParamContext = createContext({ value: null, setValue: () => { } })
export const SpeedParamContext = createContext({ value: null, setValue: () => { } })

export default function App() {
	const location = useLocation();
	const [currentTheme, setCurrentTheme] = useState(themeDesktop) // start out with themeDesktop until we know differently

	useEffect(() => {
		// Match language from different routes
		const langMatch = matchPath("/:language?", location.pathname) ||
			matchPath("/config/:productId/:language?", location.pathname) ||
			matchPath("/viewer/:productId/:language?", location.pathname) ||
			matchPath("/viewerframe/:productId/:language?", location.pathname) ||
			matchPath("/ar/:productId/:language?", location.pathname) ||
			matchPath("/manufacture2727/:language?", location.pathname) ||
			matchPath("/test/:language?", location.pathname);

		setGlobalStateItem('language', langMatch?.params?.language || localStorage.getItem("language") || "en")
	}, [location]);

	// use useReducer to allow for sequential state updates in a single render event
	const [globalState, globalDispatch] = useReducer(reducer, {
		setCurrentTheme: setCurrentTheme,
	})

	const omitBanner = true;

	// update the global state with a new state item (action.type:action.data is the key:value pair here)
	function reducer(state, action) {
		// console.log('reducer', state, action)
		return {
			...state,
			[action.type]: action.data,
		}
	}

	// set an individual state item value. This function is provided through GlobalStateContext
	function setGlobalStateItem(name, value) {
		globalDispatch({ type: name, data: value })
		if (name === 'language') localStorage.setItem("language", value)
	}

	const [currentParams, setCurrentParams] = useState({}) // these are set by input controls in the ParamsBlock
	const [speedParams, setSpeedParams] = useState({ ShowWoodgrain: 1, ShowEdges: 1, ShowFullRes: 0 }) // quality/speed options (init used to be in BlockPersonalization, which was removed)

	return (
		<GlobalStateContext.Provider value={{ globalState, setGlobalStateItem }}>
			<ThemeProvider theme={currentTheme}>
				<ParamContext.Provider value={{ currentParams, setCurrentParams }}>
					<SpeedParamContext.Provider value={{ speedParams, setSpeedParams }}>
						<Global /> {/* re-render Global every time */}
						<FullBackgroundDiv id='FullBackgroundDiv'>
							<ReactTooltip delayShow={100} />
							<ErrorBoundary>
								<Routes>
									<Route path="/:language?" element={<PageSelectorGallery />} />
									<Route path="/config/:productId/:language?" element={<PageConfigurator omitBanner={omitBanner} omitAR={false} omitUpDown={true} />} />
									<Route path="/viewer/:productId/:language?" element={<PageViewer omitBanner={omitBanner} omitAR={false} omitUpDown={true} />} />
									<Route path="/viewerframe/:productId/:language?" element={<PageViewer omitBanner={true} omitAR={true} omitUpDown={true} />} />
									<Route path="/ar/:productId/:language?" element={<PageArModelViewer />} />
									<Route path="/manufacture2727/:language?" element={<PagePersonal />} />
								</Routes>
							</ErrorBoundary>
						</FullBackgroundDiv>
					</SpeedParamContext.Provider>
				</ParamContext.Provider>
			</ThemeProvider>
		</GlobalStateContext.Provider>
	)
}

const FullBackgroundDiv = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	overflow: hidden;
	background-color: ${backgroundColor};
`
